import React, { useState } from "react";
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import IconX from '../../assets/X.png';
import { Link } from 'react-router-dom';
import Skilling01 from "../../assets/4XC/Investir/Screenshot_1.png";
import Skilling02 from "../../assets/4XC/Investir/Screenshot_2.png";
import Skilling03 from "../../assets/4XC/Investir/Screenshot_3.png";
import Skilling04 from "../../assets/4XC/Investir/Screenshot_4.png";
import Skilling05 from "../../assets/4XC/Investir/Screenshot_5.png";
import Skilling06 from "../../assets/4XC/Investir/Screenshot_6.png";
import Skilling07 from "../../assets/4XC/Investir/Screenshot_7.png";

import Header from "../Header/Header2.js";

const StyledLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: bold;
  margin-top: 1rem;

  &:hover {
    text-decoration: underline;
    filter: brightness(0.8);
  } 
`;

const StyledLink2 = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: bold;
  margin:1rem;
`;


const TitleSub2 = styled.button`
  width: 200px;
  height: 50px;
  background: none;
  cursor: pointer;
  font-weight: 600;
  color: white;
  font-size: 1.2rem;
  border-radius: 8px;
  border: 1px solid #FFC222;
  transition: 500ms;
  margin: 8px;

  &:hover{
    background: #FFC222;
  }
`;

const Fechar = styled.img``;

const Container = styled.div`
  background: #111111;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;


  @media (max-width: 1000px) {
    overflow-x: hidden !important;
  }
`;

const Title = styled.h1`
  text-align: center;
  width: 100%;
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 1rem;
`;

const TitleSub = styled.h1`
  text-align: center;
  width: 100%;
  color: #c3c3c3;
  font-size: 1.3rem;
  font-weight: 400;
  margin-bottom: 1rem;
`;

const Card = styled.div`
  width: 1080px;
  background: #151515;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 14px;
  margin: 2rem;
  position: relative;

  @media (max-width: 1000px) {
   width: 100%;
   max-width: 400px;
  }
`;

const Botao = styled.button`
  width: 250px;
  height: 50px;
  background: linear-gradient(to right, #aa7d3c, #f2cf8d);
  cursor: pointer;
  font-weight: 600;
  color: black;
  font-size: 1.2rem;
  border-radius: 8px;
  border: none;
  transition: 500ms;
  margin: 8px;

  &:hover{
    filter: brightness(0.8);
  }
`;

const Image = styled.img`
  max-width: 100%;
  margin: 20px;
`;

const BolinhasContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
`;

const Bolinha = styled.div`
  width: 24px;
  height: 10px;
  border-radius: 14px;
  margin: 0 6px;
  cursor: pointer;
  background: ${(props) => (props.selected ? '#f2cf8d' : '#c3c3c3')};

  @media (max-width: 1000px) {
   width: 10px;
  }
`;

const TextPrincipal = styled.h1`
  color: transparent;
  background: linear-gradient(to right, #aa7d3c, #f2cf8d);
  -webkit-background-clip: text;
  margin-bottom: 1rem;
`;

const SubPrincipal = styled.p`
  color: white;
  font-size: 1.2rem;
`;

const Linkada = styled.a`
  color: transparent;
  margin: 0.5rem;
  transition: 500ms;
  font-size: 1.2rem;
  background: linear-gradient(to right, #aa7d3c, #f2cf8d);
  -webkit-background-clip: text;

  &:hover{
    filter: brightness(0.8);
  }

  @media (max-width: 1000px) {
   width: 180px;
  }
`;


const Linkada2 = styled.a`
  width: 250px;
  padding: 1rem;
  text-align: center;
  color: white;
  margin: 0.5rem;
  transition: 500ms;
  font-size: 1rem;
  background: none;
  border: 1px solid white;
  border-radius: 10px;
  text-decoration: none;

  &:hover{
    filter: brightness(0.8);
  }
`;


const images = [Skilling05, Skilling06, Skilling07, Skilling01, Skilling02, Skilling03 , Skilling04, Skilling05, Skilling06, Skilling07,];

function Site() {
    const { t } = useTranslation();
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
    const nextImage = (index) => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const imageInfo = [
        {
          title: t('in.4xc.1'),
          cont: t('skillingT00'),
      },
      {
        title: t('in.4xc.7'),
        cont: t('skillingT01'),
    },
    {
      title: t('in.4xc.8'),
      cont: t('skillingT02'),
  },
        {
            title: t('in.4xc.2'),
            cont: t('skillingT03'),
        },
        {
            title: t('in.4xc.3'),
            cont: t('skillingT04')
        },
        {
          title: t('in.4xc.4'),
          cont: t('skillingT05')
      },
      {
        title: t('in.4xc.5'),
        cont: t('skillingT06')
    },
    {
      title: t('in.4xc.6'),
      cont: t('skillingT07')
  },
  {
    title: t('in.4xc.7'),
    cont: t('skillingT07')
},
{
  title: t('in.4xc.8'),
  cont: t('skillingT08')
},
    ];
    
    return (
        <Container>
            <Header/>
            <StyledLink to='/deposito-4XC'>
                <Fechar src={IconX} alt="Fechar"/>   
            </StyledLink>
            <Card>
                <Image src={images[currentImageIndex]} alt={`Skilling ${currentImageIndex + 1}`} />
                <BolinhasContainer>
                    {images.map((_, index) => (
                        <Bolinha
                            key={index}
                            selected={index === currentImageIndex}
                            onClick={() => setCurrentImageIndex(index)} // Alterado aqui
                        />
                    ))}
                </BolinhasContainer>
                <Title>{imageInfo[currentImageIndex].cont}</Title>
                <TitleSub>{imageInfo[currentImageIndex].title}</TitleSub>
                {currentImageIndex === 0 && (
                  <Linkada href="https://live.4xc.com/customer/investments/strategy/181093">https://live.4xc.com/customer/investments/strategy/181093</Linkada>
                )}
                <Botao onClick={nextImage}>{t('next.button')}</Botao>
            </Card>
        </Container>
    );
}

export default Site;
